import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar.jsx";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import blogFetch from "../../axios/config";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import UserGroupsModal from "./GroupPermissionModal";
import { IGroup } from "./GroupPermissionInterfaces";
import ModalAddGroup from "./RegisterGroup";
import ModalAddPermission from "./RegisterPermission";
import Context from "../../context/Context";
import language from "../../nls/language.json";

export default function Group() {
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalAddGroup, setShowModalAddGroup] = useState(false);
  const [showModalAddPermission, setShowModalAddPermission] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<IGroup | undefined>(
    undefined
  );
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);

  const {
    getStatusSideBar,
    selectedCountry
  } = useContext(Context);

  useEffect(() => {
    getGroups();
  }, []);

  const getGroups = async () => {
    try {
      let response = await blogFetch.get("/group");
      let data: IGroup[] = response.data;
      setGroups(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleRowClick = (group: IGroup) => {
    setSelectedGroup(group);
    setShowModal(true);
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <div className={`app_body ${getStatusSideBar()}`}>
        <div className="d-flex flex-row justify-content-end mb-3">
          <Button
            className="me-1"
            variant="contained"
            onClick={() => {
              setShowModalAddGroup(true);
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.btnAdicionarGrupo}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setShowModalAddPermission(true);
            }}
          >
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.btnAdicionarPermissao}
          </Button>
        </div>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead className="table-header">
            <TableRow>
              <TableCell>{(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.tableHeader.nome}</TableCell>
              <TableCell align="right">{(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.tableHeader.editar}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groups.map((group) => (
              <TableRow
                key={group.group_Id}
                onMouseEnter={() => setHoveredRow(group.group_Id)}
                onMouseLeave={() => setHoveredRow(null)}
                onClick={() => handleRowClick(group)}
                className="flex flex-col"
                style={{
                  cursor: "pointer",
                  backgroundColor:
                    hoveredRow === group.group_Id ? "#F5F5F5" : "transparent",
                }}
              >
                <TableCell component="th" scope="col">
                  {group.group_description}
                </TableCell>
                <TableCell component="th" scope="row" align="justify">
                  <ModeEditIcon style={{ display: "flex", alignSelf: "center" }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <UserGroupsModal
        open={showModal}
        onClose={() => setShowModal(false)}
        group={selectedGroup}
      />
      <ModalAddGroup
        open={showModalAddGroup}
        onClose={() => setShowModalAddGroup(false)}
        getGroup={getGroups}
      />
      <ModalAddPermission
        open={showModalAddPermission}
        onClose={() => setShowModalAddPermission(false)}
        getGroup={getGroups}
      />
    </>
  );
}
